/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
 */
export interface FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner
     */
    lead_full_name: string;
}

/**
 * Check if a given object implements the FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner interface.
 */
export function instanceOfFindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "lead_full_name" in value;

    return isInstance;
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSON(json: any): FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    return FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSONTyped(json, false);
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'lead_id': json['lead_id'],
        'createdAt': json['createdAt'],
        'lead_full_name': json['lead_full_name'],
    };
}

export function FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInnerToJSON(value?: FindAllExecutionsAvailableByFacilityId200ResponseDataInnerExecutionsHistoryInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'lead_id': value.lead_id,
        'createdAt': value.createdAt,
        'lead_full_name': value.lead_full_name,
    };
}

